import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const TestingButtonGroup = styled.div<{ theme: { token: GlobalToken } }>`
  height: 2.5rem;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 1.5rem;
  margin-bottom: ${({ theme: { token } }) => token.marginXL}px;
  margin-top: ${({ theme: { token } }) => token.marginXS}px;

  .end-test-button,
  .submit-report-button {
    border: 1px solid ${({ theme: { token } }) => token.colorBorder};
  }

  .cancel-test-button {
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorder};
    padding-right: ${({ theme: { token } }) => token.paddingLG}px;
    padding-left: ${({ theme: { token } }) => token.padding}px;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
  }

  .testing-progress {
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 1.2;
  }

  .test-date {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: 0.875rem;
    font-weight: normal;
    line-height: 1.2;
  }
`;

export const HistoryTestDataWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const MobileButtonContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .end-test-button,
  .submit-report-button {
    border: 1px solid ${({ theme: { token } }) => token.colorBorder};
  }

  .test-again-button {
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .cancel-test-button {
    background-color: ${({ theme: { token } }) => token.colorBgLayout};
    color: ${({ theme: { token } }) => token.colorPrimary};
  }
`;

export const ButtonGroupsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  .button-skeleton {
    margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
  }
`;
